<div class="picker-result-input" (click)="openDurationPicker($event)">
  <span class="picker-result-button">
    <mat-icon class="">timer</mat-icon>
  </span>
  <span class="picker-result-value">
    {{ pickerOutputDisplay }}
  </span>
</div>
